<jqxWindow #form [theme]="theme" [width]="1200" [height]="492" [zIndex]="50" [position]="getFormPos(form)"
    [autoOpen]="true" [zIndex]="90" [showCloseButton]="true" [showCollapseButton]="true" [resizable]="false"
    (onClose)="onClose()" (onCollapse)="onCollapse($event)" (onExpand)="onExpand($event)">
    <div class="formHeader" style="overflow-x: hidden;">
        {{translate('Informe_alarmas')}}
    </div>
    <div class="form" style="float:left; overflow: hidden;">
        <div style="float: left; margin-top: 2px; height: '100%'; width: '266px';">
            <jqxSplitter #mainSplitter [panels]="[{ min: 150, size: 260 }, { min: 915 }]" [height]="450" [width]="1185">
                <div>
                    <div class="form">
                        <span style="margin-left: 4px;">{{translate('Elementos')}}</span>
                    </div>
                    <div style="height: 440px;">
                        <app-elementos-select [conCerradura]="true"
                            (passArray)="selecElement($event)"></app-elementos-select>
                    </div>
                </div>
                <div>
                    <div style=" height: 408px;">
                        <div class="form">
                            <span style="margin-left: 4px;">{{translate('Periodo')}}</span>
                        </div>
                        <div class="group-botom" style="margin-left: 2px; display: flex;">
                            <app-periodo-select #periodoSelect [noTrimestre]="true" [noSemestre]="true" [noLibre]="true"
                                [height]="24">
                            </app-periodo-select>
                            <div style="display: flex;align-items: center;margin-left: 5px;"> <span
                                    style="margin-left: 4px;">{{translate('Lecturas')}}</span>
                                <jqxNumberInput #currencyInput [theme]="theme" [width]="50" [height]="25"
                                    [spinButtons]="true" [inputMode]="'simple'" [decimalDigits]="0"> </jqxNumberInput>
                                <span style="margin-left: 4px;">{{translate('Metros')}}</span>
                            </div>
                            <jqxButton style="float:left; margin-left: 18px;" [width]='100' [height]='22'
                                [textImageRelation]='"imageBeforeText"' [textPosition]='"center"'
                                [imgSrc]='"/assets/images/save.png"' [value]="translate('ACEPTAR')"
                                (onClick)="onAceptar($event)">
                            </jqxButton>
                            <jqxButton style="float:left; margin-left: 4px;" [width]='100' [height]='22'
                                [textImageRelation]='"imageBeforeText"' [textPosition]='"center"'
                                [imgSrc]='"/assets/images/exportar.png"' [value]="translate('Exportar')"
                                (onClick)="onExportar($event)">
                            </jqxButton>
                        </div>
                        <jqxGrid #grid [theme]="theme" [width]="'100%'" [height]="'100%'" [source]="dataAdapter"
                            [columnsresize]="true" [sortable]="true" [showrowlines]="false" [showcolumnlines]="true"
                            [columns]="columns" [altrows]="true" [enabletooltips]="true" [filterable]="true"
                            [showstatusbar]="true" [statusbarheight]="20" [showaggregates]="true" [rowsheight]="20"
                            [columnsheight]="20" [localization]="langGrid" [groupable]="true">
                        </jqxGrid>
                    </div>
                </div>
            </jqxSplitter>
        </div>
    </div>
</jqxWindow>